import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import React, { useState } from 'react';
import { useLanguage } from "../hooks/utility/useLanguage";
import { UploadedAsset } from '../types/chatTypes';
import CopyButton from './buttons/CopyButton';

interface Props {
  message: string;
  attachedDocument?: UploadedAsset;
}

// eslint-disable-next-line react/display-name
const UserChatMessageComponent: React.FC<Props> = ({ message, attachedDocument }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useLanguage();

  // Color mode values
  const messageBg = useColorModeValue('gray.100', 'gray.700');
  const textColor = useColorModeValue('gray.800', 'white');

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-end"
      justifyContent="flex-end"
      my={5}
      ml="auto"
      maxWidth="80%"
      position="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box
        bg={messageBg}
        px={4}
        py={3}
        pr={isHovered ? "32px" : 4} // Extra right padding when copy button is visible
        width="fit-content"
        borderRadius="2xl"
        borderBottomRightRadius="md"
        fontSize="15px"
        lineHeight="tall"
        position="relative"
        transition="padding-right 0.2s ease"
      >
        {/* Message text */}
        <Text color={textColor}>
          {message}
        </Text>

        {/* Copy button overlay that appears on hover */}
        {isHovered && (
          <CopyButton
            textToCopy={message}
            ariaLabel={t('common.copyMessage')}
            position="absolute"
            top="4px"
            right="4px"
            size="xs"
            variant="ghost"
            color="gray.600"
          />
        )}
      </Box>
    </Box>
  );
}

UserChatMessageComponent.displayName = 'UserChatMessage'

export const UserChatMessage = React.memo(UserChatMessageComponent)
